/**
 * API Configuration
 * Centralized configuration for API endpoints and base URLs
 */

/**
 * Get the appropriate API base URL based on the current environment
 * @returns {string} The API base URL
 */
export function getApiBaseUrl() {
  return window.location.hostname === 'localhost' 
    ? 'http://localhost:5023' 
    : 'https://api.heyitsme.app';
}

/**
 * API endpoints configuration
 */
export const API_ENDPOINTS = {
  // Account management
  CREATE_ACCOUNT: '/createAccount',
  REQUEST_SIGNUP_CODE: '/requestSignupCode',
  REQUEST_LOGIN_CODE: '/requestLoginCode',
  LOGIN: '/login',
  LOGOUT: '/logout',
  GET_ACCOUNT: '/getAccount',
  REQUEST_ACCOUNT_UPDATE_CODE: '/requestAccountUpdateCode',
  VERIFY_ACCOUNT_UPDATE_CODE: '/verifyAccountUpdateCode',
  UPDATE_ACCOUNT: '/updateAccount',
  DELETE_ACCOUNT: '/deleteAccount',
  CREATE_CHECKOUT_SESSION: '/createCheckoutSession',
  ENABLE_INCLUDED_SMS: '/enableIncludedSms',
  DISABLE_INCLUDED_SMS: '/disableIncludedSms',
  CREATE_CUSTOMER_PORTAL_SESSION: '/createCustomerPortalSession',
  
  // Moments
  CREATE_MOMENT: '/createMoment',
  GET_MOMENTS: '/getMoments',
  UPDATE_MOMENT: '/updateMoment',
  DELETE_MOMENT: '/deleteMoment',
  
  // Contact
  SUBMIT_CONTACT_FORM: '/submitContactForm',
  
  // Unsubscribe
  UNSUBSCRIBE: '/unsubscribe'
};

/**
 * Build a full API URL for a given endpoint
 * @param {string} endpoint - The API endpoint (use API_ENDPOINTS constants)
 * @returns {string} The full API URL
 */
export function buildApiUrl(endpoint) {
  return `${getApiBaseUrl()}${endpoint}`;
}
